<template>
    <b-form-group
        :id="name"
        :label="label"
        :label-for="name">
        <b-form-input
            :id="name"
            :name="name"
            type="text"
            :value="value"
            @input="$emit('input', $event)"
            required
            :placeholder="placeholder">
        </b-form-input>
    </b-form-group>
</template>

<script>
export default {
    name: 'text',
    props: ['placeholder', 'label', 'name', 'value']
}

</script>